import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { EditCampaignTemplateComponent } from './edit-campaign-template/edit-campaign-template.component';
import { CampaignTemplateService } from '../../../business-services/campaign-template.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { CampaignStepType } from '../../../business-entities/campaign-list-model';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as fromEnums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { TargetGroupRequestModel } from '../../../business-entities/campaign-modal';

@Component({
  selector: 'app-campaign-template',
  templateUrl: './campaign-template.component.html',
  styleUrls: ['./campaign-template.component.css'],
})
export class CampaignTemplateComponent implements OnInit {
  //#region Declaration
  popupCloseResult = false;
  channel = CampaignStepType;
  userRoleRightsDetails: UserRoleMenu;
  debounceTimer: any;
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  templateList: any;
  requestModal: TargetGroupRequestModel = {
    sortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    numberOfRecord: 25,
    searchTerm: '',
  };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  //#endregion
  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private userService: UserDataService,
    private campaignTemplateService: CampaignTemplateService
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.requestModal.startRecordNumber = 0;
    this.getTemplates();
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === fromEnums.ModuleNames.CampaignTemplate);
  }

  //#region API Methods
  getTemplates(isReset: boolean = true) {
    this.spinner.show();
    this.campaignTemplateService
      .getAllTemplate(this.requestModal)
      .then((res: any) => {
        if (isReset) {
          this.templateList = [];
          this.totalCount = 0;
        }
        if (res?.data.length > 0) {
          this.templateList.push(...res.data);
          this.totalCount = res.data[0].totalCount;
        }
      })
      .finally(() => this.spinner.hide());
  }
  //#endregion

  //#region Methods
  onSearch() {
    this.requestModal.startRecordNumber = 0;
    this.debounceFunction(() => this.getTemplates(), 200);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.templateList.length) {
      this.requestModal.startRecordNumber = this.templateList.length;
      this.getTemplates(false);
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModal.sortColumn = column;
    this.requestModal.sortDirection = direction;
    this.requestModal.startRecordNumber = 0;
    this.spinner.show();
    this.getTemplates();
  }
  onEdit(flag: any, templateId: any) {
    const modalref = this.modalService.open(EditCampaignTemplateComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.modelFlag = flag;
    modalref.componentInstance.templateId = templateId;
    modalref.result.then((response) => {
      if (response?.success) {
        this.ngOnInit();
      }
    });
  }

  onDelete(id: number) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(
      this.translate.instant('lblSureToDelete'),
      this.translate.instant('lblTemplate'),
      false
    );
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.campaignTemplateService
            .deleteTemplate(id)
            .then((response: any) => {
              if (response && response.statusCode == 200) {
                let deletedmsg = this.translate.instant('lblTemplateDeleted');
                this.toastr.success(deletedmsg);
                this.getTemplates();
              }
            });
        }
      }
    );
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  //#endregion
}
